import { AppBar, Box, Toolbar } from '@mui/material';
import type { FC, PropsWithChildren } from 'react';
import { SiteTitle } from '../../components/title/index.js';

export const FullscreenPage: FC<PropsWithChildren> = ({ children }) => (
  <Box sx={{ display: 'flex', height: '100%' }}>
    <AppBar
      color="secondary"
      enableColorOnDark
      position="fixed"
      sx={{ zIndex: 10000 }}
    >
      <Toolbar>
        <Box sx={{ width: '100%' }}>
          <SiteTitle />
        </Box>
      </Toolbar>
    </AppBar>
    <Box component="main" sx={{ flexGrow: 1, overflowX: 'scroll', p: 3 }}>
      <Toolbar />
      {children}
    </Box>
  </Box>
);
